import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { getClaimKey } from '../../../../../functions/get-claim-key';
import {
  FieldInspectionInfo,
  PropertyResponse,
} from '../../../../../models/api/view/claim/details/property/property-response';
import { BaseComponent } from '../../../../base/base.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-field-inspection-pr',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-12 tw-py-8">
      <app-detail-panel [dataSource]="fieldInspection" class="tw-basis-1/3">
        <app-detail-item
          label="date contact made with insured"
          name="dateContactMadeWithInsured"
          format="d"
        />
        <app-detail-item
          label="date of initial site visit"
          name="dateOfInitialSiteVisit"
          format="d"
        />
        <app-detail-item
          label="date initial estimates reported"
          name="dateInitialEstimatesReported"
          format="d"
        />
        <app-detail-item
          label="date acknowledgment sent"
          name="dateAcknowledgmentSent"
          format="d"
        />
      </app-detail-panel>

      <app-detail-panel [dataSource]="fieldInspection" class="tw-basis-1/3">
        <app-detail-item
          label="date of first report"
          name="dateOfFirstReport"
          format="d"
        />
        <app-detail-item
          label="date of final report"
          name="dateOfFinalReport"
          format="d"
        />
      </app-detail-panel>
    </div>
  `,
  styles: `
    .row div {
      height: 20px;
    }
  `,
})
export class FieldInspectionPrComponent
  extends BaseComponent
  implements OnInit
{
  claimRow: ClaimRow;
  propertyResponse: PropertyResponse;
  fieldInspection: FieldInspectionInfo;

  async ngOnInit(): Promise<void> {
    this.view.showLoading();

    const claimKey = getClaimKey();
    if (claimKey) {
      this.propertyResponse = await this.api.property.get(claimKey);
      this.fieldInspection = this.propertyResponse.fieldInspection;
    }

    this.claimRow = this.view.currentClaim();
    this.view.hideLoading();
  }
}
